import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLElement> {
  static targets = ["menu", "openIcon", "closeIcon"]

  declare readonly menuTarget: HTMLElement
  declare readonly openIconTarget: HTMLElement
  declare readonly closeIconTarget: HTMLElement

  private isOpen: boolean = false

  connect(): void {
    this.isOpen = false
  }

  toggle(): void {
    this.isOpen = !this.isOpen

    if (this.isOpen) {
      this.menuTarget.classList.remove("hidden")
      this.openIconTarget.classList.add("hidden")
      this.closeIconTarget.classList.remove("hidden")
      document.body.classList.add("overflow-hidden")
    } else {
      this.menuTarget.classList.add("hidden")
      this.openIconTarget.classList.remove("hidden")
      this.closeIconTarget.classList.add("hidden")
      document.body.classList.remove("overflow-hidden")
    }
  }

  close(): void {
    if (this.isOpen) {
      this.toggle()
    }
  }
}
